import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6ba42cc4")

_pushScopeId("data-v-6ba42cc4")
const _hoisted_1 = { class: "base-corner-card" }
const _hoisted_2 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("span", {
      style: _ctx.title.length > 10 && { fontSize: '0.75em', lineHeight: '1.2em' }
    }, _toDisplayString(_ctx.title), 5),
    (_ctx.title === 'BONUS')
      ? (_openBlock(), _createBlock("p", _hoisted_2, _toDisplayString(_ctx.bonusMoney), 1))
      : _createCommentVNode("", true)
  ]))
})